/**
 * Styles override for the Fluent `Overlay` component.
 */
export const overlayStyles = theme => ({
    root: {
    //color: theme?.semanticColors?.bodyText,
    },
});
/**
 * Styles override for the Fluent `Panel` component.
 */
export const panelStyles = theme => ({
    main: {
    //color: theme?.semanticColors?.bodyText,
    },
    // Makes Panel overlay background darker to help focus on the panel. This will help accessibility users especially with magnification. https://msazure.visualstudio.com/One/_workitems/edit/27229123
    overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)' },
});
/**
 * Styles override for the Fluent `Modal` component.
 */
export const modalStyles = theme => ({
    main: {
    //color: theme?.semanticColors?.bodyText,
    },
});
